import { render, staticRenderFns } from "./Inativar.vue?vue&type=template&id=950a0828&scoped=true"
import script from "./Inativar.vue?vue&type=script&lang=js"
export * from "./Inativar.vue?vue&type=script&lang=js"
import style0 from "./Inativar.vue?vue&type=style&index=0&id=950a0828&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950a0828",
  null
  
)

export default component.exports